export const defaultTime = (): Time => ({
    hours: 0,
    milliseconds: 0,
    minutes: 0,
    seconds: 0,
});

export interface Time {
    hours: number;
    minutes: number;
    seconds: number;
    milliseconds: number;
}

export const isSameTime = (a: Time, b: Time) =>
    a.hours === b.hours &&
    a.minutes === b.minutes &&
    a.seconds === b.seconds &&
    a.milliseconds === b.milliseconds;
